import { Box } from "@mui/material";
import React from "react";
import PhoneNumberField from "../../../../../components/common/PhoneNumberField";
import CustomTextField from "../../../../../components/common/Textfield";
import { StepComponentProps } from "../../AddBookingV2";
import StepHeader from "../StepHeader";
import VenueSearchField from "../VenueSearchField";

const ChurchServiceStep: React.FC<StepComponentProps> = ({
  bookingData,
  setBookingData,
  isEdit,
  onUpdate,
  submitting,
}) => {
  const handleChange = (field: string, value: unknown) =>
    setBookingData((prev) => ({ ...prev, [field]: value as string }));

  return (
    <Box
      sx={{ width: "100%", display: "flex", flexDirection: "column", gap: 3 }}
    >
      <StepHeader
        title="Service Details"
        isEdit={isEdit}
        onUpdate={onUpdate}
        submitting={submitting}
      />

      <Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 3 }}>
        <CustomTextField
          label="Name of Church"
          value={bookingData.church_name || ""}
          onChange={(e) => handleChange("church_name", e.target.value)}
        />
        <CustomTextField
          label="Leader Preacher's Name"
          value={bookingData.leader_preacher_name || ""}
          onChange={(e) => handleChange("leader_preacher_name", e.target.value)}
        />
        <CustomTextField
          label="Leader Preacher's Surname"
          value={bookingData.leader_preacher_surname || ""}
          onChange={(e) =>
            handleChange("leader_preacher_surname", e.target.value)
          }
        />
      </Box>

      <Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 3 }}>
        <CustomTextField
          label="Title"
          value={bookingData.title || ""}
          onChange={(e) => handleChange("title", e.target.value)}
        />
        <CustomTextField
          label="Preacher's Name"
          value={bookingData.preacher_name || ""}
          onChange={(e) => handleChange("preacher_name", e.target.value)}
        />
        <CustomTextField
          label="Preacher's Surname"
          value={bookingData.preacher_surname || ""}
          onChange={(e) => handleChange("preacher_surname", e.target.value)}
        />
      </Box>

      <Box
        sx={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr 1fr", gap: 3 }}
      >
        <CustomTextField
          label="Start Time"
          type="time"
          InputLabelProps={{ shrink: true }}
          value={bookingData.start_time || ""}
          onChange={(e) => handleChange("start_time", e.target.value)}
        />
        <CustomTextField
          label="End Time"
          type="time"
          InputLabelProps={{ shrink: true }}
          value={bookingData.end_time || ""}
          onChange={(e) => handleChange("end_time", e.target.value)}
        />
        <CustomTextField
          label="Date"
          type="date"
          InputLabelProps={{ shrink: true }}
          value={bookingData.date_of_service || ""}
          onChange={(e) => handleChange("date_of_service", e.target.value)}
        />
        {/* church_phone stored in service_notes as a workaround since it's not in BookingData */}
        <PhoneNumberField
          label="Church Phone"
          value={bookingData.representative_phone || ""}
          onChange={(value) => handleChange("representative_phone", value)}
        />
      </Box>

      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr 1fr",
          gap: 3,
          alignItems: "start",
        }}
      >
        <CustomTextField
          label="Church Email"
          value={bookingData.representative_email || ""}
          onChange={(e) => handleChange("representative_email", e.target.value)}
        />
        <VenueSearchField
          bookingData={bookingData}
          setBookingData={setBookingData}
        />
        <CustomTextField
          label="Address One"
          value={bookingData.address_one || ""}
          onChange={(e) => handleChange("address_one", e.target.value)}
          disabled={bookingData.areAddressFieldsDisabled}
        />
      </Box>

      <Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 3 }}>
        <CustomTextField
          label="Address Two"
          value={bookingData.address_two || ""}
          onChange={(e) => handleChange("address_two", e.target.value)}
          disabled={bookingData.areAddressFieldsDisabled}
        />
        <CustomTextField
          label="Suburb"
          value={bookingData.suburb || ""}
          onChange={(e) => handleChange("suburb", e.target.value)}
          disabled={bookingData.areAddressFieldsDisabled}
        />
        <CustomTextField
          label="City"
          value={bookingData.city || ""}
          onChange={(e) => handleChange("city", e.target.value)}
          disabled={bookingData.areAddressFieldsDisabled}
        />
      </Box>
    </Box>
  );
};

export default ChurchServiceStep;
